import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { EmptyState } from '@/components/feedback/EmptyState';

export function UploadNotPermitted({
  title,
  what,
}: {
  title: string;
  what: string;
}) {
  return (
    <ScrollPage>
      <PageHeader title={title} description={`You do not have access to upload ${what}.`} />
      <EmptyState
        title="Upload not available"
        description={`Only call centre admins can upload ${what}, because each file is stored under its call centre's company.`}
      />
    </ScrollPage>
  );
}

export default UploadNotPermitted;
